/* ECU Gurus — VIN check digit, shared by the search box and the buy form.

   Position 9 of a VIN is computed from the other sixteen (ISO 3779), so a
   single mistyped character is DETECTABLE instead of silently wrong. This is a
   hand-copy of vin_checksum_ok() in lookup_api/catalog.py and app.py — three
   copies of one algorithm; change one, change all three.

   ☠ BLOCK A NORTH AMERICAN VIN THAT FAILS; ONLY WARN ON ANY OTHER. The check
   digit is mandatory on every vehicle built for the US, Canada or Mexico — a VIN
   starting 1-5 — and not reliably applied elsewhere. RE-MEASURED 2026-09-25
   against the build-sheet cache: 776 VINs have a genuine Mopar sheet, and ALL 775
   of the North American ones pass (US, Canada, Mexico AND nine built here for
   export). The one real vehicle that fails is 937HL22X8Y3502283, a Brazil-built
   export Dakota. Meanwhile 17 of the 25 VINs Mopar has no record of fail the
   digit — typos. (The older "5 of 9 failing VINs have a sheet" counted cached
   FAILURES as sheets.) So a failing 1-5 VIN is a typo, and matching it hands
   the customer a confident list of parts for somebody else's vehicle. The
   export warn-and-carry-on path stays, for exactly the Brazilian Dakota case.

   ☠ AND NO "DID YOU MEAN…?". A one-character repair verified by the check digit
   was built and measured: on the only real population available it proposed a
   fix for 3 VINs and all three were already correct. A customer shown a
   suggestion clicks yes, and a wrong yes programs a unit to the wrong car. */
(function (w) {
  var TR = {A:1,B:2,C:3,D:4,E:5,F:6,G:7,H:8,J:1,K:2,L:3,M:4,N:5,P:7,R:9,
            S:2,T:3,U:4,V:5,W:6,X:7,Y:8,Z:9};
  var WT = [8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2];
  var SHAPE = /^[A-HJ-NPR-Z0-9]{17}$/;

  function clean(v) {
    var s = String(v == null ? '' : v);
    // full-width and compatibility forms (１, Ａ) are the characters they look like
    if (s.normalize) { s = s.normalize('NFKC'); }
    v = s;
    // en/em dashes and the minus sign too: a VIN pasted from a document or an
    // email arrives with them, and they are no more part of it than a space
    return String(v == null ? '' : v).trim().toUpperCase().replace(/[\s\-.\u00AD\u061C\u180E\u200B-\u200F\u2010-\u2015\u2212\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFF0D\uFFF9-\uFFFB]/g, '');
  }

  function shapeOk(vin) { return SHAPE.test(clean(vin)); }

  function checksumOk(vin) {
    vin = clean(vin);
    if (!SHAPE.test(vin)) { return false; }
    var total = 0;
    for (var i = 0; i < 17; i++) {
      var ch = vin.charAt(i);
      var val = (ch >= '0' && ch <= '9') ? Number(ch) : TR[ch];
      if (val === undefined) { return false; }
      total += val * WT[i];
    }
    var r = total % 11;
    return vin.charAt(8) === (r === 10 ? 'X' : String(r));
  }

  // World manufacturer region: 1, 4, 5 USA, 2 Canada, 3 Mexico.
  function northAmerican(vin) { return /^[1-5]/.test(clean(vin)); }

  // Right shape, wrong digit, and built where the digit is the law: a typo, not
  // a vehicle. Callers refuse these outright — see the note at the top.
  function invalid(vin) {
    return shapeOk(vin) && northAmerican(vin) && !checksumOk(vin);
  }

  /* One verdict the callers can branch on, so the wording stays in one place.
     kind: empty | short | badchar | invalid | checksum | ok
       invalid   North American, fails the digit — refuse
       checksum  anywhere else, fails the digit — warn, let them carry on */
  function inspect(v) {
    var vin = clean(v);
    if (!vin) { return {kind: 'empty', vin: vin}; }
    if (vin.length !== 17) {
      return {kind: 'short', vin: vin, need: 17 - vin.length,
              message: vin.length + ' of 17 characters.'};
    }
    if (!SHAPE.test(vin)) {
      var bad = [];
      for (var i = 0; i < vin.length; i++) {
        var c = vin.charAt(i);
        if (!/[A-HJ-NPR-Z0-9]/.test(c) && bad.indexOf(c) < 0) { bad.push(c); }
      }
      return {kind: 'badchar', vin: vin, bad: bad, message: badCharMessage(bad)};
    }
    if (!checksumOk(vin)) {
      if (northAmerican(vin)) {
        return {kind: 'invalid', vin: vin, message: INVALID};
      }
      return {kind: 'checksum', vin: vin,
              message: 'That does not pass the VIN check digit, so it may have a '
                     + 'typo. Compare it with your registration or the plate on '
                     + 'the driver-side dash.'};
    }
    return {kind: 'ok', vin: vin};
  }

  // I, O and Q get the look-alike advice; anything else is named as it is.
  function badCharMessage(bad) {
    var ioq = bad.filter(function (c) { return c === 'I' || c === 'O' || c === 'Q'; });
    var other = bad.filter(function (c) { return ioq.indexOf(c) < 0; });
    if (!other.length) { return 'A VIN never uses I, O or Q — check for a 1 or a 0.'; }
    // I, O and Q ARE letters: never lump them in with "only letters and numbers"
    var named = '“' + other.join(' ') + '” can’t be in a VIN — only letters and numbers.';
    return ioq.length ? named + ' And a VIN never uses I, O or Q.' : named;
  }

  // The refusal, worded once. The four pairs are the misreads a worn plate or a
  // phone photo actually produces; I/O/Q never get this far (shape test).
  var INVALID = 'One character is wrong: this VIN fails the check digit that every '
              + 'US, Canadian and Mexican VIN carries. Compare it character by '
              + 'character with your registration or the plate at the base of the '
              + 'windshield. Common mix-ups: S and 5, B and 8, Z and 2, G and 6.';

  w.ECUG = w.ECUG || {};
  w.ECUG.vin = {clean: clean, shapeOk: shapeOk, checksumOk: checksumOk,
                northAmerican: northAmerican, invalid: invalid,
                invalidMessage: INVALID, inspect: inspect, badCharMessage: badCharMessage};
}(window));
